import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import VirtualizedList from '../common/VirtualizedList';
import { Segment, Header } from 'semantic-ui-react';

class CustomerList extends Component {

  render() {
    const { height, width, items, onClickItem } = this.props
    const rowRenderer = ({ index, key, parent, style }) => {
      const customer = items[index]
      return(
        <Segment vertical
          key={key}
          onClick={event => onClickItem({ 
            event: event,
            index: index,
            rowData: customer 
          })} 
          style={style}
        >
          <Header size='small'>{customer.name}</Header>
          {customer.contact}
        </Segment>
      )
    }
    return <VirtualizedList
      height={height}
      width={width}
      items={items}
      rowHeight={62}
      rowRenderer={rowRenderer}
    />
  }
}

export default inject('store')(observer(CustomerList));


// WEBPACK FOOTER //
// ./src/components/customers/CustomerList.js